import Vue from 'vue'

import PagesLayout from '@/components/layouts/PagesLayout'

Vue.component('pages-layout', PagesLayout)
